import * as React from "react";
import { Icon, Grid } from './index';
import { PageHeading } from './mybswh';

class ComponentTest extends React.Component {

    render() {
        return (
            <Grid className="body-content">
                <div className="row">
                    <div className="col-12">
                        <PageHeading heading="Components" />
                        <div><Icon name="medications" /></div>
                    </div>
                </div>
            </Grid>
        );
    }

}

export default ComponentTest;
